export function Hero() {
  return (
    <section className="hero shell" aria-labelledby="hero-heading">
      <div className="hero-kicker">
        <span className="eyebrow">
          <span className="status-dot" /> FRONTEND & FULL-STACK DEVELOPMENT
        </span>
        <span className="hero-index">FABULOUS J / SELECTED WORK</span>
      </div>
      <div className="hero-title">
        <h1 id="hero-heading">
          Software
          <br />
          <span className="engineer-line">
            engineer<span className="hero-period">.</span>
          </span>
        </h1>
        <div className="hero-aside">
          <span className="hero-symbol" aria-hidden="true">
            ↳
          </span>
          <p>
            Thoughtful interfaces. <br />
            Reliable systems. <br />
            <em>Built with care.</em>
          </p>
        </div>
      </div>
      <div className="hero-bottom">
        <div className="intro-person">
          <p>
            Emmanuel Ayomiposi Adegbulu{" "}
            <span className="alias">(Fabulous J)</span>
          </p>
          <span>JavaScript · React · Next.js · TypeScript</span>
        </div>
        <p className="hero-description">
          I build interfaces and connect the systems behind them. From complex
          SaaS workflows to the details that make a product feel right.
        </p>
        <a
          className="circle-link"
          href="#work"
          aria-label="Explore selected work"
        >
          ↓
        </a>
      </div>
      <div className="hero-actions">
        <a className="button button-primary" href="#work">
          Explore my work <span aria-hidden="true">↗</span>
        </a>
        <a className="button button-outline" href="#contact">
          Let’s talk <span aria-hidden="true">↗</span>
        </a>
      </div>
    </section>
  );
}
